export default (function (_ref) {
  var data = _ref.data;
  if (!data) return {};
  var dataKeys = Object.keys(data);
  var dataAttributes = {};
  dataKeys.forEach(function (dataKey) {
    dataAttributes["data-".concat(dataKey)] = data[dataKey];
  });
  return dataAttributes;
});